const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1A535C]" data-testid="footer">
      {/* Main Footer */}
      <div className="py-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            {/* Brand */}
            <div className="md:col-span-5">
              <img
                src="https://customer-assets.emergentagent.com/job_royal-inox/artifacts/ypcsq30z_ChatGPT%20Image%20Apr%2021%2C%202026%2C%2002_31_59%20PM.png"
                alt="ROY.INOX Logo"
                className="h-[72px] w-auto mb-6"
                data-testid="footer-logo"
              />
              <p className="text-white/40 text-sm font-light leading-relaxed max-w-sm" data-testid="footer-tagline">
                Delivering world-class F&B kitchen solutions with craftsmanship, innovation, and reliability since 1997.
              </p>
            </div>

            {/* Navigation */}
            <div className="md:col-span-3">
              <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4C4A8] mb-6 font-medium" data-testid="footer-links-heading-1">
                Navigation
              </h4>
              <ul className="space-y-3">
                {['about', 'services', 'partners', 'portfolio', 'contact'].map((link) => (
                  <li key={link}>
                    <button
                      onClick={() => scrollToSection(link)}
                      className="text-white/40 text-sm font-light hover:text-white transition-colors duration-300 capitalize"
                      data-testid={`footer-link-${link}`}
                    >
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="md:col-span-4">
              <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4C4A8] mb-6 font-medium" data-testid="footer-links-heading-2">
                Contact
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="tel:+97148898577"
                    className="text-white/40 text-sm font-light hover:text-white transition-colors duration-300"
                    data-testid="footer-link-phone"
                  >
                    +971 4 8898577
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:arun@rmefandbeqpt.com"
                    className="text-white/40 text-sm font-light hover:text-white transition-colors duration-300"
                    data-testid="footer-link-email"
                  >
                    arun@rmefandbeqpt.com
                  </a>
                </li>
                <li className="text-white/40 text-sm font-light">
                  Dubai Investment Park – Phase 2<br />
                  P.O. Box 24381, Dubai, UAE
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-6 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30 font-light" data-testid="footer-copyright">
            © {currentYear} Royal Middle East International LLC
          </p>
          <p className="text-xs text-white/30 font-light tracking-widest" data-testid="footer-trademark">
            ROY.INOX
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
